var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElButton',{attrs:{"loading":_vm.loading,"type":"primary"},on:{"click":_vm.addToken}},[_vm._v("\n  "+_vm._s(_vm.$t('APP.API_AGENTS.REGENERATE_TOKEN'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }